import React from 'react';
import PropTypes from 'prop-types';
import BootstrapCard from "shared/components/bootstrapCard/BootstrapCard";
import ConnectedTextField from "shared/components/connectedTextField/ConnectedTextFieldConnector";

const AuditSelectionSection = ({ loading }) => {
  const processType = [
    { id: false, name: 'Quote' },
    { id: true, name: 'Audit' }
  ];

  const transactionType = [
    { id: '1', name: 'Sale' },
    { id: '2', name: 'Purchase' }
  ];

  const calculationType = [
    { id: '1', name: 'Forward Calculation' },
    { id: '2', name: 'Tax-Inclusive Gross Back Calculation' },
    { id: '5', name: 'Tax to Gross Back Calculation with Forced Distribution'}
  ];

  return (
    <BootstrapCard 
      title="5. Tax Calculation Processing" 
      minWidth={ 1000 } 
      loading={ loading } 
      margin={ '15px 0' }
    >
      <div>
        <ConnectedTextField name="isAudit" id="isAudit" type="materialSelectField" label="Select Quote or Audit" options={ processType } onSelect= { processType.id }/>
        <div>
          <label>Auditing transactions will write them to the Sovos Data Warehouse at the time of calculation, regardless of whether or not you decide to accrue any tax.</label>
        </div>
        <div>
          <ConnectedTextField name="transactionType" id="transactionType" type="materialSelectField" label="Select Transaction Type" options={ transactionType } />        
        </div>
        <div>
          <ConnectedTextField name="calculationType" id="calculationType" type="materialSelectField" label="Select Calculation Type" options={ calculationType } />        
        </div>
      </div>
    </BootstrapCard>
  );
};

AuditSelectionSection.propTypes = {
  loading: PropTypes.bool,
  handleSelect: PropTypes.bool  
};

AuditSelectionSection.defaultProps = { 
  loading: false
};

export default AuditSelectionSection;



// WEBPACK FOOTER //
// ./src/components/importProfile/comp/auditSelectionSection/AuditSelectionSection.js